export const civilData = {
  departmentName: "Department of Civil Engineering",
  bannerImage: "/infrastructure/civil/lab-1.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Civil Engineering at Rayalaseema University is committed to providing quality education 
    in all aspects of civil engineering. Our curriculum covers structural engineering, geotechnical engineering, 
    transportation engineering, water resources engineering, and environmental engineering. We emphasize sustainable 
    construction practices and infrastructure development, preparing students to address contemporary challenges in 
    the built environment.`,
    highlights: [
      "Well-equipped laboratories for soil mechanics, concrete testing, and surveying",
      "Focus on sustainable construction and green building technologies",
      "Research in structural health monitoring and smart materials",
      "Strong industry connections and internship programs"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/civil/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    id:'civil001',
    name: "SRI.G.VINOD KUMAR ",
    designation: "Co-ordinator & Assistant Professor (AD HOC)",
    photo: "/civil/vinodh.JPG",
    email: "vinod.civ@ruce.ac.in",
    mobile: "+91 9989981013 ",
    qualification: "B.TECH, M.TECH, (PH.D) ",
    specialization: " DEVELOPMENTAL ECONOMICS ",
    message: `Welcome to the Department of Civil Engineering. We are dedicated to nurturing civil engineers who can 
    design, construct, and maintain infrastructure that serves society while protecting the environment. Our programs 
    combine theoretical knowledge with practical skills essential for modern civil engineering practice.`,
    profileLink: "/civil/vinodh.pdf"
  },

  bos: {
    title: "Board of Studies",
    members: [
      // {
      //   name: "Prof. Gopal Krishna",
      //   designation: "Chairman",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Bharathi Devi",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Ramachandra",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Prof. External Expert",
      //   designation: "External Member",
      //   affiliation: "Industry Partner"
      // }
    ]
  },

  faculty: [
    {
      id:'civil001',
       name: "SRI.G.VINOD KUMAR ",
    designation: "Co-ordinator & Assistant Professor (AD HOC)",
    photo: "/civil/vinodh.JPG",
    email: "vinod.civ@ruce.ac.in",
    mobile: "+91 9989981013 ",
    qualification: "B.TECH, M.TECH, PH.D ",
    specialization: " DEVELOPMENTAL ECONOMICS ",
      profileLink: "/civil/vinodh.pdf"
    },
    {
      id:'civil002',
      name: "SMT. Y.DEEPTHI ",
      designation: "Assistant Professor (AD HOC)",
      email: "deepthi.civ@ruce.ac.in ",
      mobile: "+91 8897952866 ",
      photo: "/civil/deepthi.jpeg",
      qualification: "B.TECH, M.TECH",
      specialization: " DEVELOPMENTAL ECONOMICS ",
      profileLink: "/civil/deepthi.pdf"
    },
    {
      id:'civil003',
      name: "SHAIK GULNAR ",
      designation: "Assistant Professor (AD HOC)",
      email: "ramachandra@ruk.ac.in",
      mobile: "+91 98765 43258",
      photo: "/civil/ShaikGulnar.JPG",
      qualification: "B.TECH, M.TECH, PH.D ",
      specialization: "STRUCTURAL ENGINEERING ",
      profileLink: "/civil/ShaikGulnar.pdf"
    }
  ],

  courses: {
    undergraduate: [
      {
        name: "B.Tech Civil Engineering",
        duration: "4 Years",
        eligibility: "10+2 with Physics, Chemistry, and Mathematics",
        intake: "120 seats"
      }
    ]
  },

   Infrastructure: [
    "/infrastructure/civil/class-1.JPG",
    "/infrastructure/civil/class-2.JPG",
    "/infrastructure/civil/lab-1.JPG"
  ]
};
